import { Link, ModalBody, ModalHeader, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import { useTrackView } from '#src/app/shared/hooks/tracking';

import { RecommendedDecisionMakerList } from './components/RecommendedDecisionMakerList';
import type { RecommendedDecisionMaker } from './components/RecommendedDecisionMakerList/components/RecommendedDecisionMakerCard';

export type DecisionMakerRecommenderModalOptions = {
	petitionSlug: string;
	petitionId: string;
	recommendedDecisionMakers: RecommendedDecisionMaker[];
	trackingContext: string;
};

export const DecisionMakerRecommenderModalContent: React.FC<DecisionMakerRecommenderModalOptions> = ({
	recommendedDecisionMakers,
	trackingContext,
	petitionSlug,
	petitionId,
}) => {
	const track = useTracking();

	useTrackView('dm_modal_view', { context: trackingContext });

	const handleNoDmClick = (): void => {
		void track('dm_modal_other_dm_click', { context: trackingContext });
	};

	return (
		<>
			<ModalHeader title={<Translate value="corgi.components.dm_recommender.modal.title" />} />
			<ModalBody>
				<Text as="p">
					<Translate value="corgi.components.dm_recommender.modal.description" />
				</Text>
				<div className="mt-6">
					<div className="inline-flex items-center gap-2">
						<Text fontWeight="bold">
							<Translate value="corgi.components.dm_recommender.modal.subtitle" />
						</Text>
						<div className="bg-fill-brand-strong flex items-center justify-center rounded px-2">
							<Text className="text-typography-inverse-strong uppercase" size="x-small" fontWeight="bold">
								<Translate value="corgi.components.dm_recommender.modal.beta_tag" />
							</Text>
						</div>
					</div>
				</div>
				<RecommendedDecisionMakerList
					petitionId={petitionId}
					recommendedDecisionMakers={recommendedDecisionMakers}
					trackingContext={trackingContext}
				/>
				<div className="mt-6 flex flex-col items-center">
					<Text size="small">
						<Translate value="corgi.components.dm_recommender.modal.add_custom_dm.body" />
					</Text>
					<Link size="small" href={`/p/${petitionSlug}/edit#decision_makers`} onClick={handleNoDmClick}>
						<Translate value="corgi.components.dm_recommender.modal.add_custom_dm.link" />
					</Link>
				</div>
			</ModalBody>
		</>
	);
};
